export const LOADING_SEGMENT = "LOADING_SEGMENT";
export const REMOVE_SEGMENT = "REMOVE_SEGMENT";
export const ADD_SEGMENT = "ADD_SEGMENT";
export const GET_SEGMENT = "GET_SEGMENT";
export const GET_SEGMENTS = "GET_SEGMENTS";
export const UPDATE_SEGMENT = "UPDATE_SEGMENT";
export const GET_CUSTOMERS_BY_SEGMENT = "GET_CUSTOMERS_BY_SEGMENT";

